import axios from 'axios';
import Papa from 'papaparse';
import { shuffle } from 'donot';

const PATH = process.env.BASE_URL;

export async function getData() {
    const sitesCsv = await axios.get(`${PATH}data/sites.csv`);
    const questionsCsv = await axios.get(`${PATH}data/questions.csv`);
    let sitesArray = Papa.parse(sitesCsv.data, { header : true }).data;
    let questions = Papa.parse(questionsCsv.data, { header : true }).data;

    questions = questions.map((q) => {
        q.sites = q.answer1_points.split(',');
        return q;
    });

    questions = shuffle(questions);

    let sites = {};

    for (const site of shuffle(sitesArray)) {
        site.points = 0;
        site.img = `${PATH}logos/s${site.id}.jpg`;
        sites[site.id] = site;
    }

    return { sites, questions };
}